import {
  LetterheadReadonlyTextField,
  QRCode,
  ShareButton,
} from "@indietabletop/appkit";
import {
  DialogContent,
  DialogHeader,
  ScrollableDialog,
} from "../Dialog/Dialog.tsx";
import { useWarbandContext } from "../WarbandPage/useWarbandContext.ts";
import redditIcon from "./reddit.svg";
import { shareDialog } from "./style.css.ts";
import { getShareLink, useEnsureShareId } from "./useEnsureShareId.ts";

export function ShareWarbandDialog() {
  const warband = useWarbandContext();
  const result = useEnsureShareId(warband);

  const shareData = result
    .mapSuccess((snapshotId) => ({
      url: getShareLink(snapshotId),
      title: warband.name,
    }))
    .valueOrNull();

  const inputValue = result.unpack(
    (snapshotId) => getShareLink(snapshotId),
    (message) => message,
    () => `Loading...`,
  );

  const redditShareUrl = result
    .mapSuccess(
      (value) =>
        `https://reddit.com/r/Greathelm/submit?${new URLSearchParams({
          url: getShareLink(value),
          title: `Check out my Greathelm warband ${warband.name}!`,
          type: "LINK",
        })}`,
    )
    .valueOrNull();

  const urlResult = result.mapSuccess((snapshotId) => getShareLink(snapshotId));

  return (
    <ScrollableDialog>
      <DialogHeader heading="Share warband" />
      <DialogContent>
        <div>
          <p className={shareDialog.info}>
            Share this version of {warband.name} with the world! If you make
            changes, you will need to generate a new link for others to see
            them.
          </p>

          <LetterheadReadonlyTextField label="Share URL" value={inputValue} />

          <div className={shareDialog.row}>
            <ShareButton
              className={shareDialog.button}
              shareData={shareData}
              copyLabel="Copy link"
              shareLabel="Share link"
            />

            <a
              className={shareDialog.redditButton}
              href={redditShareUrl ?? undefined}
              title="Share on Reddit"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src={redditIcon}
                alt="Share on Reddit"
                style={{ maxInlineSize: "3rem", margin: "-1rem -0.5rem" }}
              />
            </a>
          </div>
        </div>

        <div className={shareDialog.inPersonSharing}>
          <div className={shareDialog.inPersonHeading}>Sharing in person?</div>
          <p>Let your friends scan this QR code.</p>
        </div>

        <div className={shareDialog.qrContainer}>
          <QRCode url={urlResult} className={shareDialog.qr} />
        </div>
      </DialogContent>
    </ScrollableDialog>
  );
}
